import * as Yup from "yup";

export const AdminLoginSchema = Yup.object({
  identifier: Yup.string()
    .required("This field is required")
    .test(
      "is-valid-identifier",
      "Enter a valid email, phone number, or username",
      function (value) {
        if (!value) return false;

        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        const isPhone = /^[6-9]\d{9}$/.test(value); // Adjust based on your country's phone format
        const isUsername = /^[a-zA-Z0-9_]{3,30}$/.test(value); // Simple username rules

        return isEmail || isPhone || isUsername;
      }
    ),
  password: Yup.string()
    .max(255, "Password must not be greater than 255 characters.")
    .required("Password is required."),
});

export const RegisterSchema = Yup.object({
  username: Yup.string()
    .max(255, "User name must not be greater than 255 characters.")
    .required("User name is required."),
  password: Yup.string()
    .max(255, "Password must not be greater than 255 characters.")
    .required("Password is required."),
  confirm_password: Yup.string().oneOf(
    [Yup.ref("password")],
    "Password and Confirm Password did not Match"
  ),
  name: Yup.string()
    .max(255, "Name must not be greater than 255 characters.")
    .required("Name is required."),
  gender: Yup.string().required("Gender is required."),
  age: Yup.string().required("Age is required."),
  number: Yup.string()
    .max(10, "Contact number must not be greater than 10 characters.")
    .required("Contact number is required."),
});

export const RoleAddSchema = Yup.object({
  subcategory_name: Yup.string().required("Subcategory name is required"),
  category_id: Yup.number()
    .typeError("Category is required")
    .required("Category is required"),
});

export const CategoryAddSchema = Yup.object({
  name: Yup.string().required("Category name is required"),
});

export const RoleEditSchema = Yup.object({
  name: Yup.string().required("Name is required"),
});

export const PermisisonAddSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  permission_name: Yup.string().required("permission name is required"),
});

export const PermisisonEditSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  permission_name: Yup.string().required("permission name is required"),
});

export const AssignOrderSchema = Yup.object({
  supplier_id: Yup.array().required("Supplier is required"),
});

export const DesignStudioAddSchema = Yup.object({
  name: Yup.string().required("Name is required"),
});

export const DesignStudioEditSchema = Yup.object({
  name: Yup.string().required("Name is required"),
});

export const DesignStudioForwardSchema = Yup.object({
  order_id: Yup.string().required("Order is required"),
});

export const SupplierAddSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  company_name: Yup.string().required("Company name is required"),
  gst_number: Yup.string()
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST Number"
    )
    .required("GST Number is required"),

  email: Yup.string().required("Email is required"),
  phone: Yup.string()
    .max(10, "Contact number must not be greater than 10 characters.")
    .required("Contact number is required."),
  supplier_type: Yup.string().required("Supplier Type is required"),
  company_logo: Yup.string().required("Company Logo is required"),
});

export const buyerAddSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  company_name: Yup.string().required("Company name is required"),
  gst_number: Yup.string()
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST Number"
    )
    .required("GST Number is required"),
  email: Yup.string().required("Email is required"),
  phone: Yup.string()
    .max(10, "Contact number must not be greater than 10 characters.")
    .required("Contact number is required."),
});

export const ProductAddSchema = Yup.object({
  title: Yup.string().required("Product Name is required"),
  description: Yup.string().required("Description is required"),
  // price: Yup.number().required("Price is required").min(0, "Price must be positive"),
  // category: Yup.string().required("Category is required"),
  // sub_category: Yup.string().required("Sub Category is required"),
  // sku: Yup.string().required("SKU is required"),
  // product_image: Yup.string().required("Product Image is required"),
  // gallery_image_path: Yup.string().required("Gallery Images are required"),
  // paper_gsm: Yup.array().required("Paper GSM is required"),
  // print_coverage: Yup.array().required("Print Coverage is required"),
  // burst_factor: Yup.array().required("Burst Factor is required"),
  // no_of_ply: Yup.array().required("No of Ply is required"),
  // lamination: Yup.string().required("Lamination is required"),
  // quantity: Yup.number().required("Quantity is required").min(1, "Quantity must be at least 1"),
});

export const ProductEditSchema = Yup.object({
  // title: Yup.string().required("Product Name is required"),
  // description: Yup.string().required("Description is required"),
  // price: Yup.number().required("Price is required").min(0, "Price must be positive"),
  // category: Yup.string().required("Category is required"),
  // sub_category: Yup.string().required("Sub Category is required"),
  // sku: Yup.string().required("SKU is required"),
  // product_image: Yup.string().required("Product Image is required"),
  // gallery_image_path: Yup.string().required("Gallery Images are required"),
  // paper_gsm: Yup.array().required("Paper GSM is required"),
  // print_coverage: Yup.array().required("Print Coverage is required"),
  // burst_factor: Yup.array().required("Burst Factor is required"),
  // no_of_ply: Yup.array().required("No of Ply is required"),
  // lamination: Yup.string().required("Lamination is required"),
  // quantity: Yup.number().required("Quantity is required").min(1, "Quantity must be at least 1"),
});

export const UserPermissionAddSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  designation: Yup.string().required("Designation is required"),
  email: Yup.string().email().required("Email is required"),
  mobile_number: Yup.string()
    .max(10, "Contact number must not be greater than 10 characters.")
    .required("Contact number is required."),
  role_id: Yup.string().required("Role is required"),
  module_id: Yup.array().required("Module is required"),
  sub_module_id: Yup.array().required("Sub Module is required"),
  // permission_id:Yup.array().required("Permission is required"),
});

export const UserPermissionEditSchema = Yup.object({
  designation: Yup.string().required("Designation is required"),
  module_id: Yup.array()
    .min(1, "At least one module is required")
    .required("Module is required"),
  sub_module_id: Yup.array()
    .min(1, "At least one sub-module is required")
    .required("Sub Module is required"),
});

export const BlogAddSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  // auther_image: Yup.string().required("Auther Image is required"),
  // category: Yup.string().required("Category is required"),
  // tags: Yup.array().of(Yup.string()).required("At least one tag is required"),
});

export const SolutionAddSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  image_path: Yup.string().required("Image path is required"),
});

export const AssignSalesExecutiveSchema = Yup.object({
  sales_executive_id: Yup.string().required("Sales Executive is required"),
  // userId: Yup.string().required("Order is required"),
});

// export const AssignGraphicDesignerSchema = Yup.object({
//   graphic_designer_id: Yup.string().required("Graphic Designer is required"), //31-08
//   // userId: Yup.string().required("Order is required"),
// });

export const BlogAddCategorySchema = Yup.object({
  name: Yup.string().required("Name is required"),
});

export const RevertBackSchema = Yup.object({
  remark: Yup.string().required("Remark is required"),
  price: Yup.string().required("Price is required"),
});

export const AddGraphicDesignSchema = Yup.object({
  remark: Yup.string().required("Remark is required"),
  price: Yup.string().required("Price is required"),
});

export const FinalQuotationSchema = Yup.object({
  final_description: Yup.string().required("Description is required"),
  final_price: Yup.string().required("Price is required"),
});
